import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectAccountsListItems } from '../../../../../redux/accounts/selector';
import { accounts } from '../../../../../redux/accounts/action';
import PageLoader from '../../../../../components/PageLoader';
import ContactsComponent from '../components/contacts.component';
import storePersist from '../../../../../redux/storePersist';
import { selectTagNamesListItems } from '../../../../../redux/tag-names/selector';
import { tagNames } from '../../../../../redux/tag-names/action';
import { setDisplayText } from '../../../../../common/services/tag-names.service';
import { tags } from '../../../../../redux/tags/action';
import { selectTagsListItems } from '../../../../../redux/tags/selector';
import { selectCrmcontactsQueryItems } from '../../../../../redux/crm-contacts/selector';
import { crmcontacts } from '../../../../../redux/crm-contacts/action';

const Oneusercontact = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const tagentityMappingslist = useSelector(selectTagsListItems)
    const queryItems = useSelector(selectCrmcontactsQueryItems)
    const accountListItems = useSelector(selectAccountsListItems)
    const tagNameListItems = useSelector(selectTagNamesListItems)
    const libraryListItems = storePersist.get("library")?.current;
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [selectedContact, setSelectedContact] = useState<any>([])

    const fetchTagEntityMapping = async (contactId: number) => {
        await dispatch(tags.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/setting/global-settings/tags/tag-entity-mappings/list`,
            entity: 'tagMapping',
            jsonData: {
                Filters: [
                    {
                        FieldName: 'OwnerType',
                        FieldType: 'text',
                        FilterOperatorId: 1,
                        FieldValue: 'Contact'
                    },
                    {
                        FieldName: 'OwnerId',
                        FieldType: 'number',
                        FilterOperatorId: 1,
                        FieldValue: contactId
                    }
                ]
            }
        }));
    };
    const fetchTags = () => {
        dispatch(tagNames.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/setting/global-settings/tags/tag-values/list`,
            entity: 'tagNames',
            jsonData: {}
        }))
    }
    const fetchContactById = async () => {
        dispatch(crmcontacts.query({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/contacts/query`,
            entity: 'contacts',
            jsonData: {
                Records: [
                    {
                        "Id": parmas?.id
                    }
                ]
            }
        }))
        await fetchTagEntityMapping(parmas?.id);
        setIsQuery(true)

    }

    const handleInnerFormChange: any = (event: any, field: string) => {
        setSelectedContact({ ...selectedContact, [field]: event })
    }

    useEffect(
        () => {
            dispatch(accounts.list({
                url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/rms/accounts/fetch`,
                entity: 'accounts',
                jsonData:
                {
                    Context: {},
                    Records: [
                        {
                            TypeId: 0
                        }
                    ],
                    Pagination: {
                    }
                }
            })).then(() => {
                if (parmas?.id > 0) {
                    fetchContactById()
                    fetchTags()
                    setIsLoading(false)
                } else {
                    setIsLoading(false)
                }
            })
        }, []
    )

    useEffect(
        () => {
            if (isQuery && tagentityMappingslist) {
                const contact = queryItems?.result?.items;
                const tagMapping = tagentityMappingslist?.result?.items?.[0];

                if (contact) {
                    setSelectedContact({
                        ...contact,
                        TagEntityMappingsValueIds: tagMapping?.Id ?? ''
                    });
                }
                else {
                    setSelectedContact(queryItems?.result?.items)
                }
            }
        }, [isQuery, tagentityMappingslist]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        if (parmas?.id > 0) {
            if (selectedContact?.TagEntityMappingsValueIds) {
                dispatch(tags.create({
                    url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/setting/global-settings/tags/tag-entity-mappings`,
                    entity: 'tags',
                    jsonData: {
                        Records: [

                            { "ValueId": selectedContact?.TagEntityMappingsValueIds, "EntityId": parmas?.id, "EntityType": "Contact", "EntityTypeId": 8 }

                        ]
                    }
                }))
            }
            dispatch(crmcontacts.update({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/contacts`,
                entity: 'contacts',
                jsonData: {
                    Records: [
                        {
                            ...selectedContact
                        }
                    ]
                }
            })).then(() => {
                back()
            })
        } else {
            dispatch(crmcontacts.create({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/contacts`,
                entity: 'contacts',
                jsonData: {
                    Records: [
                        {
                            ...selectedContact
                        }
                    ]
                }
            })).then(() => {
                back()
            })
        }
    }

    const back = () => {
        navigate('/agencies/sales/contacts')
    }


    return (
        <>
            {isLoading ? <PageLoader /> :
                <ContactsComponent
                    handleInnerFormChange={handleInnerFormChange}
                    selectedContact={selectedContact}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    accounts={accountListItems?.result?.items}
                    salutation={libraryListItems?.Salutation}
                    contactSource={libraryListItems?.ContactSource}
                    tagNames={setDisplayText(tagNameListItems?.result?.items)}
                    id={parmas?.id}
                    tags={setDisplayText(tagentityMappingslist?.result?.items)}

                />
            }
        </>
    )
}

export default Oneusercontact;